import React from "react";
import './index.css'
const InputText = ({ placeholder, type }) => {
  const handleInputChange = (e) => {
    const inputField = e.target;
    if (inputField.value.trim()) {
      inputField.style.color = "white";
      inputField.style.fontStyle = "italic";
    } else {
      inputField.style.color = "black";
      inputField.style.fontStyle = "normal";
    }
  };

  return (
    <>
      <input
        type={type}
        className="form-control"
        placeholder={placeholder}
        style={{
          backgroundColor: "transparent",
          border: "1px solid gray",
          padding: "10px",
          outline: "none",
          color: "black", 
          fontStyle: "normal",
        }}
        onChange={handleInputChange}
      />
    </>
  );
};

export default InputText;
